export const SKIP_GLOBAL_LOADING_HEADER = 'X-Skip-Global-Loading';
export const SKIP_ERROR_HANDLER_HEADER = 'X-Skip-Error-Handler';
